var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F13A3A",
    d: "M0 13.103C0 16.36 2.686 19 6 19s6-2.64 6-5.897c0-3.275-1.667-5.896-.548-8.19 0 0-1.785.328-2.785 2.95 0 0-3.334-3.277-1.941-7.863 0 0-3.393 1.31-3.038 5.569.304 3.652-.355 4.259-.355 4.259 0-2.949-2.345-4.259-2.345-4.259C1.667 9.172 0 10.155 0 13.103z",
    transform: "translate(-844.000000, -4979.000000) translate(700.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(12.000000, 7.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB446",
    d: "M4.333 12.448c-.333 1.966-1 2.681-1 3.931C3.333 17.69 4.527 19 6 19c1.483 0 2.67-1.191 2.667-2.649-.012-3.915-2.334-5.868-2.334-5.868.334 1.965-.666 2.948-.666 2.948-.417-.614-1.334-.983-1.334-.983z",
    transform: "translate(-844.000000, -4979.000000) translate(700.000000, 4560.000000) translate(16.000000, 384.000000) translate(116.000000, 28.000000) translate(12.000000, 7.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.1963e3cb.svg";
export { ForwardRef as ReactComponent };